// extracted by mini-css-extract-plugin
export var labelWrapper = "_dg-0";